import { useState } from "react";
import { useGridApiRef } from "@mui/x-data-grid-pro";

import { FilterGroupState } from "features/ui/Filters/FilterBuilder/types";

/**
 * Manages MaterialTable toolbar state and actions &
 * provides apiRef for DataGrid control and filter panel state management.
 */
export const useTableToolbar = (filters?: FilterGroupState) => {
  const apiRef = useGridApiRef();
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);

  const handleFilterClick = () => {
    if (isFilterPanelOpen) {
      apiRef.current?.hideFilterPanel();
    } else {
      apiRef.current?.showFilterPanel();
    }
  };

  const activeFilterCount = filters
    ? Object.keys(filters.children || {}).length
    : 0;

  return {
    apiRef,
    isFilterPanelOpen,
    setIsFilterPanelOpen,
    handleFilterClick,
    activeFilterCount,
  };
};
